<template>
  <div id="main-container">
    <template v-if="not_found">
      <NotFound />
    </template>
    <router-view v-if="!not_found" v-slot="{ Component, route }">
      <keep-alive max="10">
        <component
          :is="Component"
          :key="route.meta.usePathKey ? route.path : undefined"
          view-prop="value"
        />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
const uiStore = createNamespacedHelpers("ui");
import NotFound from "@/components/shared/NotFound.vue";
import _ from "lodash";

export default {
  name: "MainView",
  setup() {
    const { SHOW_NOT_FOUND, HIDE_NOT_FOUND } = uiStore.useMutations([
      "SHOW_NOT_FOUND",
      "HIDE_NOT_FOUND",
    ]);
    return { SHOW_NOT_FOUND, HIDE_NOT_FOUND };
  },
  data: function () {
    return {
      not_found: false,
    };
  },
  components: {
    NotFound,
  },
  watch: {
    $route() {
      this.$log.debug("$route update...");
      this.HIDE_NOT_FOUND();
      this.check_page_found();

      if (this.$route.query.log) {
        this.setLogLevel(this.$route.query.log);
      }
    },
    page_not_found() {
      this.$log.debug();
      this.check_page_found();
    },
  },
  mounted() {
    this.$log.debug();
    this.check_page_found();
  },
  computed: {
    page_not_found() {
      return this.$store.getters["ui/get_not_found"];
    },
  },
  methods: {
    check_page_found() {
      this.$log.debug(
        `checking $route name=${_.get(
          this.$route,
          "name",
          null
        )} and path=${_.get(this.$route, "path", null)}`
      );
      const not_found = this.$store.getters["ui/get_not_found"];
      if ((!this.$route.name && this.$route.path != "/") || not_found) {
        this.$log.debug("not found...");
        this.not_found = true;
      } else {
        this.$log.debug("found...");
        this.not_found = false;
      }
    },
    setLogLevel(log) {
      switch (log) {
        case "debug":
        case "warn":
        case "info":
        case "error":
          console.info(
            `[INFO] [MainView.vue:setLogLevel:89] SETTING LOG LEVEL TO ${log}`
          );
          this.$log.apply({ level: log });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss">
#main-container {
  height: 100%;
}

.v-navigation-drawer .v-list {
  padding: 0 !important;
}

.v-icon {
  background-color: transparent !important;
}

.v-content__wrap {
  z-index: 6;
  -webkit-box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
}
</style>
